import API from 'services/TAPS_API';
import { NDFL3_NOTIFICATION_ID } from '../../constants';
import sendSignedDocument from './signedDocument';

const requrest = (url, data, method = 'POST') => {
  return API.request({
    method,
    url,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data,
  });
};

const save3NDFLXmlDraft = (payload) => {
  return requrest(`/notification/${NDFL3_NOTIFICATION_ID}/save`, payload);
};

const getYears = () => {
  return requrest(`/notification/${NDFL3_NOTIFICATION_ID}/schemes`, {}, 'GET');
};

const validateXML = (fileLink, inn, formatVersion, originalFilename) => {
  return requrest(
    `/notification/${NDFL3_NOTIFICATION_ID}/validate?formatVersion=${formatVersion}&originalFilename=${originalFilename}&fileLink=${fileLink}`,
    {},
    'GET',
  );
};

const submitDeclaration = (data) => {
  return requrest(`/notification/${NDFL3_NOTIFICATION_ID}/submit`, data);
};

/**
 * Send declaration with the specified year
 * @param {Number} year
 * @param {Object} data
 */
const sendDeclaration = (year) => {
  return (data, docId, version) => {
    return sendSignedDocument(data, `${docId}/${year}`, version);
  };
};

export { save3NDFLXmlDraft, getYears, validateXML, submitDeclaration, sendDeclaration };
